import { useState } from 'react';
import { Plus, Minus, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { faqSections } from '../lib/faqData';

// Pick the 5 most conversion-critical questions
const homepageFAQs = [
  faqSections[0].items[0], // "What is your response time for IT support requests?"
  faqSections[5].items[0], // "How much does IT support cost for a small business?"
  faqSections[5].items[1], // "Do you offer free consultations?"
  faqSections[5].items[2], // "What is included in your managed IT services?"
  faqSections[1].items[0], // "Do you install network cabling for new offices?"
];

export function HomepageFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-navy-950 border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-4">
            Common Questions
          </h2>
          <p className="text-gray-300 text-center mb-12 text-lg">
            Quick answers to what Treasure Valley businesses ask us most.
          </p>

          <div className="space-y-3">
            {homepageFAQs.map((item, index) => (
              <div
                key={index}
                className="border border-white/5 rounded-2xl overflow-hidden bg-navy-800/30 transition-all duration-300 hover:border-white/10"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between p-6 text-left"
                  aria-expanded={openIndex === index}
                >
                  <span className="font-semibold text-lg text-white pr-8">{item.question}</span>
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === index ? 'bg-cobalt-500 text-white' : 'bg-white/10 text-gray-400'}`}>
                    {openIndex === index ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </div>
                </button>
                <div
                  className="grid transition-all duration-200 ease-in-out"
                  style={{
                    gridTemplateRows: openIndex === index ? '1fr' : '0fr',
                    opacity: openIndex === index ? 1 : 0,
                  }}
                >
                  <div className="overflow-hidden">
                    <div className="px-6 pb-6 pt-0">
                      <p className="text-gray-300 leading-relaxed text-base border-t border-white/5 pt-4">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link
              to="/faq"
              className="inline-flex items-center text-cobalt-400 hover:text-cobalt-300 font-medium transition-colors"
            >
              View All FAQ
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
